module.exports = __webpack_public_path__ + "img/AnyMobile.db850ecb.png";